import { gql } from '@apollo/client';

export const GET_INSPECTION_CONFIGURATION = gql`
  query GetInspectionConfiguration($regionId: String!) {
    getCreateInspectionConfig(regionId: $regionId) {
      defaultReInspectionPeriod
      mode
      read
      rw
      propertyTypes {
        type
        name
      }
      inspectionTypes {
        type
        name
      }
      inspectionRole {
        type
        name
      }
      onSiteInspectionSections {
        ...InspectionQuestionSection
      }
      inspectionResult {
        success {
          header_html
          body_html
        }
        fail {
          header_html
          body_html
        }
      }
    }
  }

  fragment InspectionQuestionSection on InspectionQuestionSection {
    title
    type
    optional
    notes {
      mode
      attachments
      title
    }
    questions
  }
`;
